import styled from 'styled-components';

import { overrideProperties } from '@ecp/common/src/style/utils';
import { sizePropTypes } from '@ecp/common/src/style/propTypes';
import { FlexBox } from '@ecp/common/src/layouts/flex/styled';
import { ReactComponent as Question } from '@ecp/common/src/assets/icon/question.svg';

export const MainContentsBox = styled(FlexBox)`
  width: 100%;
  min-width: 1540px;
  max-width: 1540px;
`;

export const MainHeroBannerHorizontal = styled(FlexBox)`
  width: 100%;
  min-width: 1920px;
  max-width: 1920px;
`;

export const MainHeroBannerVertical = styled(FlexBox)`
  width: 100%;
`;

export const MainContentsTitle = styled(FlexBox)`
  ${overrideProperties(sizePropTypes, {
    width: '100%',
    height: '45px',
  })};

  font-weight: ${(props) => props.theme.font.weight.medium};
  font-size: ${(props) => props.theme.font.size.large};
  line-height: ${(props) => props.theme.font.lineHeight.demiLight};
  color: ${(props) => props.theme.color.text.basic};
  justify-content: space-between;
`;

export const QuestionIcon = styled(Question)`
  width: 18px;
  height: 18px;
  cursor: pointer;
`;
